import { SVGIconComponent } from './types';

export const Download: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Action/Download" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M13,4 C17.96395,4 22,8.0360725 22,13 C22,17.964775 17.9638,22 13,22 C8.03617,22 4,17.964775 4,13 C4,8.0360725 8.0360725,4 13,4 Z M13,5.5 C8.8645,5.5 5.5,8.8645 5.5,13 C5.5,17.13625 8.8645,20.5 13,20.5 C17.1355,20.5 20.5,17.13625 20.5,13 C20.5,8.8645 17.1355,5.5 13,5.5 Z M8.84848987,9.24460775 C9.15507851,8.93801911 9.64961136,8.93535303 9.9512554,9.23699707 L9.9512554,9.23699707 L15.5510425,14.8367841 L15.57178,11.7237529 C15.5747437,11.2943145 15.9272879,10.9417703 16.3567263,10.9388066 L16.3567263,10.9388066 C16.7876496,10.9373275 17.1346191,11.2842971 17.1316554,11.7137356 L17.1316554,11.7137356 L17.0971854,16.7083376 C17.0979687,16.8115729 17.0763193,16.9134654 17.035258,17.009507 C16.9964476,17.1032984 16.9390063,17.1889729 16.8659287,17.2620504 C16.7928511,17.335128 16.7064165,17.3933288 16.6103853,17.4328924 C16.5173476,17.4724372 16.4147114,17.4933429 16.3114676,17.4940554 L16.3114676,17.4940554 L11.3183978,17.5285148 C11.1104069,17.5299445 10.9149478,17.4504946 10.7685804,17.3041271 C10.6229414,17.1584882 10.5427573,16.9622949 10.5441927,16.7543097 C10.547155,16.3249084 10.8982053,15.9723745 11.3283959,15.9686587 L11.3283959,15.9686587 L14.4414271,15.9479211 L8.84087919,10.3473733 C8.53849335,10.0449874 8.54265333,9.55044429 8.84848987,9.24460775 Z"
        id="Combined-Shape"
        fill="#848484"
        transform="translate(13.000000, 13.000000) rotate(45.000000) translate(-13.000000, -13.000000) "
      ></path>
    </g>
  </svg>
);
